import { Component, OnInit, EventEmitter, Output } from '@angular/core';

// Services
import { ModalsService } from 'src/app/core/services/modals/modals.service';
import { EmitDataService } from '../../../../core/services/emit-data/emit-data.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})

export class ModalComponent implements OnInit {
  mensaje: string;
  tipo = '';
  modulo: string;
  textoUsabilidad: string;
  imagen = '';
  timeout = 0;
  boton: true;
  botonText = 'VOLVER';

  constructor(
    private modalService: ModalsService,
    private emitDataService: EmitDataService
  ) { }

  ngOnInit() {
    if (Number(this.timeout) !== 0) {
      setTimeout(() => {
        this.closeModal();
      }, this.timeout);
    }
  }

  closeModal() {
    if (this.modulo === 'bono-ges') {
      this.modalService.closeModal();
      this.emitDataService.enviarDato('centro-medico');
    }

    this.modalService.closeModal();
    this.tipo = '';
    this.mensaje = '';
    this.imagen = '';
    this.timeout = 0;
    this.boton = true;
  }
}
